export default __webpack_public_path__ + "static/media/Z_Zebra.7db63397.svg";